var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name:'dashboard'}}},[_c('img',{staticStyle:{"margin-top":"-8px","margin-left":"-12px"},attrs:{"src":require("@/assets/logo1.png"),"alt":"logo"}}),(_vm.showTitle)?_c('h1',{staticStyle:{"margin-top":"-8px"}},[_vm._v(_vm._s(_vm.title))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }